// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pyk7","content":"styles_content__3uWOp","tableWrap":"styles_tableWrap__1Viw1"};